import { render, staticRenderFns } from "./EventLeavePage.vue?vue&type=template&id=6ba10dad"
import script from "./EventLeavePage.vue?vue&type=script&lang=js"
export * from "./EventLeavePage.vue?vue&type=script&lang=js"
import style0 from "./EventLeavePage.vue?vue&type=style&index=0&id=6ba10dad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports